(() => {
  class ShCategoryFinder extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-rail]');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.toggle = this.querySelector('[data-toggle]');

      if (this.rail && (this.prev || this.next)) {
        this.prev?.addEventListener('click', () => this.scrollByCard(-1));
        this.next?.addEventListener('click', () => this.scrollByCard(1));
        this.rail.addEventListener('scroll', () => this.syncArrows(), { passive: true });
        this.syncArrows();
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(() => this.syncArrows());
          this.observer.observe(this.rail);
        }
      }

      this.toggle?.addEventListener('click', () => {
        const expanded = this.classList.toggle('is-expanded');
        this.toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    get step() {
      const card = this.rail.querySelector('[data-card]');
      if (!card) return this.rail.clientWidth;
      const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    scrollByCard(direction) {
      this.rail.scrollBy({ left: this.step * direction, behavior: 'smooth' });
    }

    syncArrows() {
      const max = this.rail.scrollWidth - this.rail.clientWidth;
      const x = this.rail.scrollLeft;
      const scrollable = max > 1;
      this.prev?.toggleAttribute('hidden', !scrollable || x <= 1);
      this.next?.toggleAttribute('hidden', !scrollable || x >= max - 1);
    }
  }

  if (!customElements.get('sh-category-finder')) {
    customElements.define('sh-category-finder', ShCategoryFinder);
  }
})();
